<section class="container-wrapper">
    <div class="loading-spinner" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20">
      </mat-progress-spinner>
    </div>

    <div *ngIf="!loading" [formGroup]="form">
      <section>
        <app-form-input
          label="{{'pages.config-all.config-contact.website' | translate}}"
          formControlName="website"
          data-cy="website"
        >
          <app-form-error *ngIf="website.touched && website.invalid && website.value">
            {{ 'pages.config-all.config-contact.error.website' | translate }}
          </app-form-error>
        </app-form-input>
      </section>
      <div class="row justify-end">
        <button class="bciti-button" [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'" (click)="submit()"
          [disabled]="processingSubmit">
          <span>{{ 'pages.config-all.config-contact.submit' | translate }}</span>
        </button>
      </div>
    </div>
  </section>
